import axios from "axios";
import { toast } from "react-toastify";
import { axiosErrorHandler } from "utilzify";

import { checkToastThemeOption } from "@/utils";
import { get } from "lodash";

const http = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API_URL,
});

const msgLogger = (data: unknown, message: string) => {
  const error = get(data, "response.data.msg", "") || "";
  const errors = error.split(",").length ? error.split(",").map(e => e.trim()) : [message];
  errors.forEach(err => toast.error(err, checkToastThemeOption()));
};

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem("t$o@k!en*");
    const authorization = token ? `Token ${token}` : "";
    config.headers.Authorization = authorization;

    return config;
  },
  axiosErrorHandler(msgLogger, false),
);

http.interceptors.response.use(res => res, axiosErrorHandler(msgLogger, false));

export default http;
